import type { SbEditableComponentProps } from "types/storyblok";
import { AutocompleteForm } from "modules/common/components";
import { AutocompleteFormTabs } from "modules/common/components/AutocompleteForm/experiment/AutocompleteFormTabs";
import { AutocompleteMultilegForm } from "modules/common/components/AutocompleteForm/experiment/AutocompleteMultilegForm";
import { useOptimizely } from "hooks/useOptimizely";
import type { HeroFormProps } from "./HeroForm.d";
import { InfoCheckmarks } from "./InfoCheckmarks/InfoCheckmarks";
import { Uploader } from "./Uploader/Uploader";

export const HeroForm = ({
  ctaVariant = "primary",
  buttonText = undefined,
  checkmarks = [],
  hideCheckmarks = false,
  sbEditable,
  formVariant = "wide",
}: SbEditableComponentProps<HeroFormProps>) => {
  const { variation } = useOptimizely({
    experimentName: "Homepage connecting flights (mobile)",
    experimentId: 25762140628,
    variations: {
      3393779832353471: 0, // original variant
      6052368761766217: 1,
      7134436980663927: 2,
    },
    pages: [
      { language: "en-int", slug: "" },
    ],
  });

  const renderForm = () => {
    switch (variation) {
      case 1:
        return (
          <AutocompleteMultilegForm
            ctaVariant={ctaVariant}
            buttonText={buttonText}
            sbEditable={sbEditable}
            variant={formVariant}
            isMultiLeg
          />
        );
      case 2:
        return <AutocompleteFormTabs ctaVariant={ctaVariant} buttonText={buttonText} variant={formVariant} />;
      default:
        return (
          <AutocompleteForm
            ctaVariant={ctaVariant}
            buttonText={buttonText}
            sbEditable={sbEditable}
            variant={formVariant}
          />
        );
    }
  };

  return (
    <>
      {renderForm()}
      <Uploader />
      {hideCheckmarks || <InfoCheckmarks checkmarks={checkmarks} />}
    </>
  );
};
